function e(a, s, c) {
  a[s] = Object.assign(a[s] ?? {}, c);
}
export {
  e as assignNamespace
};
